import { ChangeEvent, useEffect } from 'react'
import { FormControl, NativeSelect } from '@mui/material'

import { useAccountLanguages, useLanguages } from 'src/hooks'

interface IProps {
  locale: string
  handleLocale: (locale: string) => void
}

export const AccountLocaleSelect = ({ locale, handleLocale }: IProps) => {
  const { data: locales } = useAccountLanguages()
  const { data } = useLanguages()

  const languages: any = {}

  data?.data.forEach((item) => {
    languages[item.code] = item.code.toUpperCase()
  })

  useEffect(() => {
    if (!locales) return

    const localeExists = locales.find((l) => l.code === locale)
    if (!localeExists && locales.length > 0) {
      handleLocale(locales[0].code)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locales])

  if (!locales?.length) return null

  function handleChange(event: ChangeEvent<HTMLSelectElement>) {
    const code = event.target.value
    if (locale === code) return
    handleLocale(code)
  }

  if (locales.length !== 1) {
    return (
      <FormControl size="small" margin="none">
        <NativeSelect value={locale} onChange={handleChange}>
          {locales?.map((locale) => (
            <option key={locale.id} value={locale.code}>
              {languages[locale.code]}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
    )
  } else {
    return <></>
  }
}
